// extracted by mini-css-extract-plugin
export default {"title":"PatientListGeneralSettings_title__VLnXL","input":"PatientListGeneralSettings_input__5lMFh","field":"PatientListGeneralSettings_field__3l6Ts"};